import React, { useState, useEffect } from 'react'

const GlassPanel = ({ children, className = "" }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                     window.innerWidth < 768
      setIsMobile(mobile)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <div className={`bg-white/10 ${isMobile ? '' : 'backdrop-blur-xl'} rounded-2xl shadow-2xl border border-white/20 p-8 ${className}`}>
      {children}
    </div>
  )
}

export default GlassPanel